export default __webpack_public_path__ + "static/media/futura-medium.a0ceb76a.woff2";